import React, {useEffect, ReactElement} from 'react';
import {useBoolean} from 'src/hooks/useBoolean';
import Form from './Form';
import Display from './Display';
import {CompleteColumnSettings, ItemValue, PersistedItemValue} from './types';

const Row = (props: {
  destroy: (id: string) => void;
  createOrUpdate: (item: ItemValue | PersistedItemValue) => Promise<void>;
  columns: CompleteColumnSettings[];
  values: PersistedItemValue;
  forceEdit?: boolean;
  disableUpdating?: boolean;
  disableDeleting?: boolean;
  apiFieldMap?: Record<string, string>;
}): ReactElement => {
  const editing = useBoolean(false);
  const forceEditing = useBoolean(false);
  const bulkSave = useBoolean(false);

  useEffect(() => {
    if (props.forceEdit) {
      forceEditing.setTrue();
    } else if (forceEditing.value && !bulkSave.value) {
      bulkSave.setTrue();
    }
  }, [props.forceEdit]);

  if (editing.value || forceEditing.value || bulkSave.value) {
    return (
      <Form
        createOrUpdate={props.createOrUpdate}
        afterSubmit={() => {
          editing.setFalse();
          bulkSave.setFalse();
          forceEditing.setFalse();
        }}
        values={props.values}
        apiFieldMap={props.apiFieldMap}
        columns={props.columns}
        showClearButton
        renderNonEditableFields
        showButton={forceEditing.value || bulkSave.value ? undefined : 'Save'}
        bulkSave={bulkSave.value}
      />
    );
  }

  return (
    <Display
      columns={props.columns}
      setEditing={props.disableUpdating ? editing.setFalse : editing.setTrue}
      destroy={props.destroy}
      disableDeleting={props.disableDeleting}
      values={props.values}
    />
  );
};

export default Row;
